"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLock(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 0 14 24" }, props),
        React.createElement("path", { d: "M12 4a5 5 0 015 5h.25c.912 0 1.667.635 1.744 1.436l.006.135v7.858c0 .818-.707 1.496-1.6 1.565l-.15.006H6.75c-.912 0-1.667-.635-1.744-1.436L5 18.429V10.57c0-.818.707-1.496 1.6-1.565L6.75 9H7a5 5 0 015-5zm0 2a3 3 0 00-3 3h6a3 3 0 00-3-3z", fill: "currentColor", fillRule: "evenodd" })));
}
exports.default = tombacIcon_1.default('Lock')(SvgLock);
//# sourceMappingURL=Lock.js.map